export const lightGroupsConfig = {
  subsolo01: [
    { id: "grupo38", modulo: "5", idx: "6", descricao: "Circuito", lightType: "normal",
      instances: [
        { x: 500, y: 0, width: 2.5, height: 5, circleNumber: 38 },
      ]
    },
  ]
};